<script setup>
import AppIcon from '../../atoms/app/AppIcon.vue';

const props = defineProps({
    text: {
        type: String,
        required: true,
    },
    icon: {
        type: String,
    },
    dataQa: {
        type: String,
        default: 'snackbar',
    },
});

defineExpose({ props });
</script>

<template>
    <div
        class="c-appSnackbar"
        :data-qa="dataQa"
    >
        <div class="k-c-snackbar k-c-snackbar--toggle">
            <div class="k-c-snackbar__content">
                <AppIcon
                    v-if="icon"
                    :name="icon"
                    :class="'c-appSnackbar__icon--' + icon"
                    class="k-c-snackbar__icon"
                    :data-qa="icon + ' icon'"
                />
                <span data-qa="text">{{ text }}</span>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
@use '~@karriereat/global-styles/scss/components/snackbar/index' as snackbar;
@use '~@karriereat/global-styles/scss/settings/spacing';

$z-index-snackbar: 9999;

.c-appSnackbar {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: $z-index-snackbar;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: spacing.$k-spacing--l;
    margin-left: spacing.$k-spacing--l;

    &__icon {
        &--success {
            color: var(--k-gray-900);
        }
    }
}
</style>
